<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? ``
						: `transaction/parent/${parent_id}/update-children`
				"
			>
				<div
					class="form-group row align-items-center"
					v-if="!selectedUrl"
				>
					<label for="inputs_lead_id" class="col-sm-3 mb-0">
						Children
					</label>
					<app-input
						id="inputs_lead_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_lead_id"
						@input="setLeadId"
						:fetch-url="'transaction/lead?deactivate_rbac=1'"
						placeholder="Select Children"
						list-value-field="full_name"
					/>
				</div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "SiblingInformationTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					product_category_id: undefined,
					code: "",
					name: "",
					is_active: "",
					product_category: {
						id: undefined,
						code: "",
						name: "",
						is_active: "",
					},
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			modalId: this.formId,
			modalTitle: this.$t("add"),
			inputs: {
				children: [],
			},
			parent_id: this.value?.parent?.id || 0,
			input_lead_id: this.value
				? this.value.lead
					? {
							id: this.value.lead.id || 0,
							clc_id_number: this.value.lead.clc_id_number || "",
							full_name: this.value.lead.full_name || "",
					  }
					: {
							id: this.value.lead?.id || 0,
							clc_id_number: this.value.lead?.clc_id_number || "",
							full_name: this.value.lead?.full_name || "",
					  }
				: {
						id: this.value.lead.id || 0,
						clc_id_number: this.value.lead.clc_id_number || "",
						full_name: this.value.lead.full_name || "",
				  },
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(
				this.inputs,
				"transaction/parent/" + this.parent_id + "/update-children"
			);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
		setLeadId(data) {
			if (data && data.hasOwnProperty("id")) {
				this.inputs.children.push(data.clc_id_number);
			}
		},
	},
};
</script>
